import Vue from 'vue';
import App from './src/compare/App.vue';
import store from './src/compare/store';

Vue.config.productionTip = false;

window.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('#compare');

  if (el) {
    new Vue({
      store,
      render: h => h(App),
      data: () => Object.assign({}, el.dataset),
    }).$mount(el);
  }
});
